const config = {
  ENVIRONMENT_NAME: 'prod',
  forwoodId: {
    URL: 'https://id.demo.forwoodsafety.com',
    USER_TOKEN_URL: 'https://4v2nbh59oa.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://2u0ckz8tr4.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'teams-container-1.11.7',
    HOSTNAME: 'https://teams.demo.forwoodsafety.com',
    TEAMS_MICROFRONTEND_URL: 'https://teams-service.demo.forwoodsafety.com',
    TARGETS_MICROFRONTEND_URL: 'https://targets.demo.forwoodsafety.com',
    TEAMS_ACCESS_ROLE: 'TeamsAccess',
    TEAM_TARGETS_ACCESS_ROLE: 'TeamTargetsAccess',
  },
  configurationService: {
    URL: 'https://config.demo.forwoodsafety.com',
    WEBSOCKET: 'wss://4ttf2gjoi3.execute-api.us-west-2.amazonaws.com/prod'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
